<template>
  <div
    class="modal fade form-modal fullscreen-modal dark show modal-sample-achievement-video"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="cta-header"></div>
          <button
            class="close"
            type="button"
            @click="$emit('close')"
          ></button>
        </div>
        <div class="modal-body p-0">
          <iframe
            class="modal-sample-achievement-video__iframe"
            allow="autoplay; fullscreen"
            allowfullscreen
            src="https://player.vimeo.com/video/796303153?autoplay=1"
            >&nbsp;
          </iframe>
        </div>
        <div class="modal-footer border-top-0 flex-column">
          <button
            type="button"
            class="btn btn-link no-thanks-link text-smaller"
            data-dismiss="modal"
            :aria-label="a11yContent.closeAriaLabel"
            @click="$emit('close')"
          >
            {{ commonContent.closeLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import useModal from '@/composables/modal'

import { a11yContent } from '@/content/a11y'
import { commonContent } from '@/content/common'

export default defineComponent({
  name: 'ModalSampleAchievementVideo',
  setup() {
    useModal()
    return { commonContent, a11yContent }
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/mixins';

.modal.fullscreen-modal {
  @include modal-fullscreen;
}

.modal-sample-achievement-video {
  display: block;

  .modal-content {
    height: 90vh;
  }

  &__iframe {
    width: 100%;
    height: 84vh;
    border: 0;
  }
}
</style>
